'use es6';

import withDebouncedInput from 'DesignEditorsUI/components/shared/inputs/withDebouncedInput';
export default function debouncedInput() {
  return withDebouncedInput;
}